import { render } from "./BuildingCreate.vue?vue&type=template&id=3ab9de5a&scoped=true"
import script from "./BuildingCreate.vue?vue&type=script&lang=js"
export * from "./BuildingCreate.vue?vue&type=script&lang=js"

import "./BuildingCreate.vue?vue&type=style&index=0&id=3ab9de5a&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab9de5a"]])

export default __exports__